module.exports = __webpack_public_path__ + "img/bmark-icon.d87af1c1.png";